import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class CustomMissingTranslationHandler extends MissingTranslationHandler {
  private warns = new Set<string>();

  handle({ key, translateService }: MissingTranslationHandlerParams): any {
    const lang = translateService.currentLang;
    const warn = `Missing ${lang} translation: ${key}`;
    if (!this.warns.has(warn)) {
      console.warn(warn);
      this.warns.add(warn);
      this.appendToMissingTranslationsFile(key, key);
    }
    return key;
  }

  private appendToMissingTranslationsFile(key: string, value: string): void {
    try {
      // Create the npm run command for adding translations
      const command = `pnpm run add-translations '${key}' '${value}'`;

      // In a browser environment, we can't directly write to files
      // But we can log the command that should be added to the script
      console.log(`Add to missing-translations.sh: ${command}`);

      // Store only the keys in localStorage (much more efficient)
      const existingKeys = localStorage.getItem('missing-translation-keys') || '';
      const keys = existingKeys ? existingKeys.split(',') : [];
      if (!keys.includes(key)) {
        keys.push(key);
        localStorage.setItem('missing-translation-keys', keys.join(','));
      }

      // Also create/append to missing-translations.sh file if not present
      this.createMissingTranslationsFile(key, value);
    } catch (error) {
      console.error('Error handling missing translation:', error);
    }
  }

  private createMissingTranslationsFile(key: string, value: string): void {
    try {
      // Create the npm run command
      const command = `pnpm run add-translations '${key}' '${value}'`;

      // Since we can't write files directly from browser, we'll show a warning
      // and provide instructions for manual creation
      console.warn(`Missing translation detected: ${key}`);
      console.warn(`Please add this line to missing-translations.sh:`);
      console.warn(command);

      // Store in a special localStorage key for the script to pick up
      const existingCommands = localStorage.getItem('missing-translation-commands') || '';
      const commands = existingCommands ? existingCommands.split('\n') : [];
      if (!commands.includes(command)) {
        commands.push(command);
        localStorage.setItem('missing-translation-commands', commands.join('\n'));
      }
    } catch (error) {
      console.error('Error creating missing translations file entry:', error);
    }
  }
}
